import { GET_RECEIPTS_BY_PATIENT, SEND_RECEIPTS_TO_PATIENT_VIA_WA } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface Response<T = ResponseEntity> {
    success: boolean;
    data?: T[];
}
export interface ResponseEntity {
    aid: string;
    updated_at: Date;
    created_at: Date;
    receipt_id: number;
    receipt_url: string;
    net_amount: number;
}
export interface Payment {
    st?: number | null;
    td: number | string;
    gt?: number | null;
}
export interface Paymode {
    id: string;
    name: string;
}
export interface ServiceEntity {
    id: string;
    name: string;
    cost: Cost;
    ind: number;
    paymode: Paymode;
}
export interface Cost {
    curr: string;
    price: number;
    qty?: number;
    discount?: number;
    total?: number;
}
export interface User {
    phone: string;
    name: string;
}

export default (ptId: string): Promise<Response> =>
    fetchWithRefresh(GET_RECEIPTS_BY_PATIENT(ptId), {
        mode: 'cors',
        credentials: 'include',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not fetch receipts for patient');
        }
    });

export function sendReceiptWAMessage(docId: string, receipt_id: number): Promise<Response<null>> {
    return fetchWithRefresh(SEND_RECEIPTS_TO_PATIENT_VIA_WA(docId, receipt_id), {
        mode: 'cors',
        credentials: 'include',
        method: 'PUT',
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not fetch receipts for patient');
        }
    });
}
